import { Injected, WalletConnect } from "./connectors";

export const WALLETS = [
    {
        name: "Metamask",
        connector: Injected
    },
    {
        name: "Wallet Connect",
        connector: WalletConnect
    }
]